module.exports = __webpack_public_path__ + "static/header-image-8b049fe421ac3eb58c9a0e5df5c3115c.png";